<script lang="ts">
	import PrimaryButton from '$lib/buttons/primaryButton.svelte';
	import type { AccordionCategory } from '../accordion/types';
	import { preloadData } from '$app/navigation';
	import type { Snippet } from 'svelte';

	interface Props {
		tabs?: AccordionCategory[];
		selectedTab?: string | null;
		class?: string;
		onselect?: (slug: string | null) => void;
		helpDesktop?: Snippet;
	}

	let {
		tabs = [],
		selectedTab = null,
		class: className = 'flex-row overflow-x-scroll lg:overflow-x-visible',
		onselect,
		helpDesktop
	}: Props = $props();
</script>

<div class="scrollbar-hide flex gap-x-2 py-4 lg:py-0 {className}">
	<PrimaryButton
		class="-ml-1"
		theme={!selectedTab ? 'purple' : 'purple-2'}
		onclick={() => {
			onselect?.(null);
		}}
		onmouseenter={() => preloadData('/faq')}
	>
		All
	</PrimaryButton>

	{#each tabs as tab}
		<PrimaryButton
			wrapperClass="-ml-1"
			class="max-sm:whitespace-nowrap"
			theme={selectedTab === tab.slug ? 'purple' : 'purple-2'}
			onclick={() => {
				onselect?.(tab.slug);
			}}
			onmouseenter={() => preloadData(`/faq/${tab.slug}`)}
		>
			{tab.name}
		</PrimaryButton>
	{/each}

	<div class="max-md:hidden">
		{@render helpDesktop?.()}
	</div>
</div>
